import { render } from "./SubscribeUser.vue?vue&type=template&id=2f31a49b&scoped=true"
import script from "./SubscribeUser.vue?vue&type=script&lang=js"
export * from "./SubscribeUser.vue?vue&type=script&lang=js"

import "./SubscribeUser.vue?vue&type=style&index=0&id=2f31a49b&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f31a49b"]])

export default __exports__